import template from './sw-cms-el-config-acris-blog-group.html.twig';
import './sw-cms-el-config-acris-blog-group.scss';

const { Component, Mixin } = Shopware;
const { EntityCollection, Criteria } = Shopware.Data;

Component.register('sw-cms-el-config-acris-blog-group', {
    template,

    mixins: [
        Mixin.getByName('cms-element')
    ],

    inject: ['repositoryFactory'],

    data() {
        return {
            expanded: false
        }
    },

    computed: {
        blogGroup() {
            return this.repositoryFactory.create('acris_blog_group');
        },

        blogGroupCriteria() {
            const criteria = new Criteria();

            criteria.addFilter(Criteria.equals('active', true));

            return criteria;
        },

        layoutOptions() {
            return [{
                label: this.$tc('acris-blog.elements.blogGroup.config.label.layoutBoxOption'),
                value: 'box'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.label.layoutListOption'),
                value: 'list'
            }];
        },

        paginationHorizontalAlignmentOptions() {
            return [{
                label: this.$tc('acris-blog.elements.blogGroup.config.label.paginationHorizontalAlignmentOptions.start'),
                value: 'start'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.label.paginationHorizontalAlignmentOptions.center'),
                value: 'center'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.label.paginationHorizontalAlignmentOptions.end'),
                value: 'end'
            }];
        },

        aspectRatioOptions() {
            return [{
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption1'),
                value: '1'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption2'),
                value: '2'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption3'),
                value: '3'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption4'),
                value: '4'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption5'),
                value: '5'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption6'),
                value: '6'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption7'),
                value: '7'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption8'),
                value: '8'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption9'),
                value: '9'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption10'),
                value: '10'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption11'),
                value: '11'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption12'),
                value: '12'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption13'),
                value: '13'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption14'),
                value: '14'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption15'),
                value: '15'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption16'),
                value: '16'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption17'),
                value: '17'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption18'),
                value: '18'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption19'),
                value: '19'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption20'),
                value: '20'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption21'),
                value: '21'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption22'),
                value: '22'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption23'),
                value: '23'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption24'),
                value: '24'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption25'),
                value: '25'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption26'),
                value: '26'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption27'),
                value: '27'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption28'),
                value: '28'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption29'),
                value: '29'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.imageOptimisation.aspectRatioOption30'),
                value: '30'
            },];
        },

        blogColumnOptions() {
            return [{
                label: this.$tc('acris-blog.elements.blogGroup.config.label.oneOption'),
                value: '1'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.label.twoOption'),
                value: '2'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.label.threeOption'),
                value: '3'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.label.fourOption'),
                value: '4'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.label.fiveOption'),
                value: '5'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.label.sixOption'),
                value: '6'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.label.sevenOption'),
                value: '7'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.label.eightOption'),
                value: '8'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.label.nineOption'),
                value: '9'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.label.tenOption'),
                value: '10'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.label.elevenOption'),
                value: '11'
            }, {
                label: this.$tc('acris-blog.elements.blogGroup.config.label.twelveOption'),
                value: '12'
            }];
        },

        aspectRatioSelectClasses() {
            return [
                'acris-image-aspect-select'
            ]
        },

        buttonTypeOptions() {
            return [
                {
                    label: this.$tc('acris-blog.elements.blogGroup.config.label.primary'),
                    value: 'primary',
                },
                {
                    label: this.$tc('acris-blog.elements.blogGroup.config.label.secondary'),
                    value: 'secondary',
                },
                {
                    label: this.$tc('acris-blog.elements.blogGroup.config.label.success'),
                    value: 'success',
                },
                {
                    label: this.$tc('acris-blog.elements.blogGroup.config.label.danger'),
                    value: 'danger',
                },
                {
                    label: this.$tc('acris-blog.elements.blogGroup.config.label.warning'),
                    value: 'warning',
                },
                {
                    label: this.$tc('acris-blog.elements.blogGroup.config.label.info'),
                    value: 'info',
                },
                {
                    label: this.$tc('acris-blog.elements.blogGroup.config.label.light'),
                    value: 'light',
                },
                {
                    label: this.$tc('acris-blog.elements.blogGroup.config.label.dark'),
                    value: 'dark',
                }
            ];
        },

        displayModeOptions() {
            return [
                {
                    label: this.$tc('acris-blog.elements.blogGroup.config.label.displayModeStretch'),
                    value: 'stretch',
                },
                {
                    label: this.$tc('acris-blog.elements.blogGroup.config.label.displayModeCover'),
                    value: 'cover',
                },
            ];
        }
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.initElementConfig('acris-blog-group');

            if (this.element.config.groups.value.length === 0) {
                this.element.config.groups.value = this.createBlogGroupCollection();
            } else {
                const emptyBlogGroup = this.createBlogGroupCollection();
                this.element.config.groups.value.forEach((value) => {
                    emptyBlogGroup.add(value);
                });

                this.element.config.groups.value = emptyBlogGroup;
            }

            if (Object.keys(this.element.config.articleSettings.value).length === 0) {
                this.createArticleDisplaySettings();
            }

            this.element.config.articleSettings.value = Object.entries(this.element.config.articleSettings.value).sort((a, b) => a[1].position - b[1].position).reduce((acc, [key, value]) => ({
                ...acc,
                [key]: value
            }), {});
        },

        createBlogGroupCollection() {
            return new EntityCollection('/acris_blog_group', 'acris_blog_group', Shopware.Context.api, new Criteria());
        },

        onImageLinkedClick(viewport) {
            const item = this.element.config.articleSettings.value.image.acris_image_fixed_aspect_ratio_viewports[viewport];

            if (item.linked === true) {
                item.linked = false;
            } else {
                item.linked = true;

                item.aspect_width = this.element.config.articleSettings.value.image.acris_image_fixed_aspect_ratio_viewports.acris_image_settings_xl.aspect_width;
                item.aspect_height = this.element.config.articleSettings.value.image.acris_image_fixed_aspect_ratio_viewports.acris_image_settings_xl.aspect_height;
            }
        },

        onAspectChange(type, value, name) {
            // For viewports that are not Desktop ('acris_image_settings_xl')
            // We want to only change current viewport value and not every that is not linked
            if (name === 'acris_image_settings_xl') {
                for (const key in this.element.config.articleSettings.value.image.acris_image_fixed_aspect_ratio_viewports) {
                    // skip loop if the property is from prototype
                    if (!this.element.config.articleSettings.value.image.acris_image_fixed_aspect_ratio_viewports.hasOwnProperty(key)) continue;

                    const viewport = this.element.config.articleSettings.value.image.acris_image_fixed_aspect_ratio_viewports[key];

                    if (viewport instanceof Object && key !== 'acris_image_settings_xl') {
                        if (key === 'acris_image_settings_lg' || key === 'acris_image_settings_md' || key === 'acris_image_settings_sm' || key === 'acris_image_settings_xs') {
                            const isLinked = viewport.linked;
                            // Change all linked viewports
                            if (isLinked) {
                                viewport[type] = value;
                            }
                        }
                    }
                }
            }
        },

        movePosition(index, newPosition) {
            const currentObj = { ...this.element.config.articleSettings.value[index] };

            const replacedPosition = currentObj.position === newPosition ? Object.keys(this.element.config.articleSettings.value).indexOf(index) + 1 : currentObj.position;

            for (const [key, item] of Object.entries(this.element.config.articleSettings.value)) {
                if (currentObj.position === newPosition) {
                    // input change
                    if (item.position === newPosition && key !== index) {
                        this.element.config.articleSettings.value[key].position = replacedPosition;
                        this.$set(this.element.config.articleSettings.value[key], 'position', replacedPosition);
                    }
                } else {
                    // arrow up or down
                    this.element.config.articleSettings.value[index].position = newPosition;
                    if (item.position === newPosition && key !== index) {
                        this.element.config.articleSettings.value[key].position = replacedPosition;
                    }
                }
            }

            this.element.config.articleSettings.value = Object.entries(this.element.config.articleSettings.value).sort((a, b) => a[1].position - b[1].position).reduce((acc, [key, value]) => (
                {
                    ...acc, [key]: value
                }), {});
        },

        createArticleDisplaySettings() {
            this.element.config.articleSettings.value = {
                category: {
                    active: false,
                    position: 1,
                    fontColor: '',
                    fontSize: null
                },
                image: {
                    active: true,
                    position: 2,
                    displayMode: 'stretch',
                    minHeight: 200,
                    acris_image_fixed_aspect_ratio_active: true,
                    acris_image_fixed_aspect_ratio_viewports: {
                        acris_image_settings_xl: {
                            aspect_width: '1',
                            aspect_height: '1',
                            position_x: 0,
                            position_y: 0,
                            size: 100
                        },
                        acris_image_settings_xs: {
                            linked: true,
                            aspect_width: '1',
                            aspect_height: '1',
                            position_x: 0,
                            position_y: 0,
                            size: 100
                        },
                        acris_image_settings_lg: {
                            linked: true,
                            aspect_width: '1',
                            aspect_height: '1',
                            position_x: 0,
                            position_y: 0,
                            size: 100
                        },
                        acris_image_settings_md: {
                            linked: true,
                            aspect_width: '1',
                            aspect_height: '1',
                            position_x: 0,
                            position_y: 0,
                            size: 100
                        },
                        acris_image_settings_sm: {
                            linked: true,
                            aspect_width: '1',
                            aspect_height: '1',
                            position_x: 0,
                            position_y: 0,
                            size: 100
                        }
                    }
                },
                title: {
                    active: true,
                    position: 3,
                    fontColor: '',
                    fontSize: null
                },
                subtitle: {
                    active: false,
                    position: 4,
                    fontColor: '',
                    fontSize: null
                },
                overview: {
                    active: true,
                    position: 5,
                    fontColor: '',
                    fontSize: null
                },
                author: {
                    active: false,
                    position: 6,
                    fontColor: '',
                    fontSize: null
                },
                date: {
                    active: true,
                    position: 7,
                    fontColor: '',
                    fontSize: null
                },
                button: {
                    active: true,
                    position: 8,
                    text: '',
                    type: 'primary',
                    outline: false
                },
            }
        }
    }
});
